import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { LeaveService } from '../../../Model/Leave/leave.service';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-advance-expense-approval-detail',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, LoaderComponent],
  templateUrl: './advance-expense-approval-detail.component.html',
  styleUrl: './advance-expense-approval-detail.component.scss'
})
export class AdvanceExpenseApprovalDetailComponent {
  isDisabled: boolean = false;
  isSuper: boolean = false;//for super admin
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;

  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null as any,
    EmpMasterId: null,
    EmpCode: null,
    Photo: null as any,
    EmployeeName: null as any,
    DesignationName: null as any,
    RequestDate: null,
    TripName: null,
    FromDate: null,
    ToDate: null,
    Description: null,
    AdvanceAmount: null as any,
    ApprovedAmount: null as any,
    EmpType: null as any,
    ApprovalStatus: null as any,
  }
  Trackings = [];
  TrackingsUser = [];
  user = [] as any;

  Filter = {
    ModuleMasterId: 15,
    WebESSApprovalRequestTrackingId: 0,
    FromDate: null,
    ToDate: null,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    TransactionId: 0,
    EmpType: null,
    Remark: null,
    isShowError: false,
  }

  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    private leave: LeaveService,
    protected tooltip: TooltipService,
    private userright: UserRightService,
    private expense: ExpenseService,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    if (window.location.pathname.includes('todo')) {
      this.GetID = 1;
    } else if (window.location.pathname.includes('request')) {
      this.Filter.EmpMasterId = this.user.UserId;
      this.GetID = 2
    }
  }

  ngOnInit(): void {
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    if (this.GetID == 1) {
      this.ApprovalMatrixRequestGet();
      //if (this.user.UserType == 'A') {
      this.ESS_GetUserRole();
      //}
    } else if (this.GetID == 2) {
      this.ESS_ExpenseAdvanceRequest_SelectUpdate();
    }
  }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 15) {
          if (response.Table.length > 0) {
            this.DetailData = response.Table[0];
          } else if (response.Table1.length > 0) {
            this.DetailData = response.Table1[0];
          } else if (response.Table2.length > 0) {
            this.DetailData = response.Table2[0];
          } else if (response.Table3.length > 0) {
            this.DetailData = response.Table3[0];
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestProcess(SelectType: string) {
    if (this.DetailData.ApprovedAmount > this.DetailData.AdvanceAmount) {
      this.toast.show({ message: 'Not allow to add approve amount greater than advance amount.', type: toastTypeEnum.warning });
    } else if (this.DetailData.ApprovedAmount == '' || this.DetailData.ApprovedAmount == null || this.DetailData.ApprovedAmount <= 0) {
      this.toast.show({ message: 'Not allow to add approve amount in minus or blank.', type: toastTypeEnum.warning });
    } else {
      if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
        modalRef.result.then((result: any) => {
          if (result) {
            this.isDisabled = true;
            if (this.DetailData.ApprovedAmount != this.DetailData.AdvanceAmount) {
              const updateDate: { ESS_ExpenseAdvanceRequestId: any; ApprovedAmount: any; }[] = [];
              updateDate.push({
                ESS_ExpenseAdvanceRequestId: this.DetailData.TransactionId,
                ApprovedAmount: this.DetailData.ApprovedAmount,
              })

              this.expense.Proc_ESS_ExpenseAdvanceUpdateAtApproval({ SelectType: 'u', ESS_ExpenseAdvanceRequest: updateDate, }).subscribe({
                next: (response) => {
                  if (response.Error_Code == '490') {
                    this.RequestAR(SelectType);
                  } else {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => { });
                    this.isDisabled = false;
                  }
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            } else {
              this.RequestAR(SelectType);
            }

          }
        }).catch(() => { });
      } else {
        this.Filter.isShowError = true;
        this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
      }
    }
  }

  ESS_ExpenseAdvanceRequest_SelectUpdate() {
    this.isDisabled = true;
    this.expense.ESS_ExpenseAdvanceRequest_SelectUpdate({ ApprovalStatus: 'All', TripId: null, SelectType: 1, ESS_ExpenseAdvanceRequestId: this.Filter.WebESSApprovalRequestTrackingId, EmpMasterId: this.Filter.EmpMasterId, }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.DetailData.WebESSApprovalRequestTrackingId = 0;
          this.DetailData.TransactionId = response.Table[0].TransactionId;
          this.DetailData.EmpMasterId = response.Table[0].EmpMasterId;
          this.DetailData.EmpCode = response.Table[0].EmpCode;
          this.DetailData.Photo = response.Table[0].Photo;
          this.DetailData.EmployeeName = response.Table[0].EmployeeName;
          this.DetailData.DesignationName = response.Table[0].DesignationName
          this.DetailData.RequestDate = response.Table[0].RequestDate;
          this.DetailData.TripName = response.Table[0].TripName;
          this.DetailData.FromDate = response.Table[0].FromDate;
          this.DetailData.ToDate = response.Table[0].ToDate;
          this.DetailData.Description = response.Table[0].Description;
          this.DetailData.AdvanceAmount = response.Table[0].AdvanceAmount;
          this.DetailData.ApprovedAmount = response.Table[0].ApprovedAmount;
          this.DetailData.EmpType = response.Table[0].EmpType;
          this.DetailData.ApprovalStatus = response.Table[0].ApprovalStatus;
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  RequestAR(SelectType: string) {
    this.isDisabled = true;
    //this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
    this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
      next: (response) => {
        if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.router.navigate(['/todo/advanceapproval/']);
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ExpenseFolder + '/' + Text;
  }

  Cancel() {
    if (this.GetID == 1) {
      if (this.user.UserType == 'A') {
        this.router.navigate(['/todo/advanceapproval/']);
      } else if (this.user.UserType == 'E') {
        this.router.navigate(['/request/advanceexpense/approval/']);
      }
    } else if (this.GetID == 2) {
      this.router.navigate(['/request/advanceexpense/']);
    }
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  removeError() {
    this.Filter.isShowError = false;
  }
}
